import fetch from '@/helpers/fetch'
import tableHelper from '@/helpers/table'

export default {
	state: {
		trialsList: null,
		trialsTotal: null,
		calledOffset: null,
		secondaryNumbersList: null,
		trialsBySecondaryNumbers: null
	},
	mutations: {
		SET_TRIALS_LIST(state, trials) {
			state.trialsList = state.trialsList || []
			state.trialsList = state.trialsList.concat(trials)
		},

		SET_CALLED_OFFSET(state, offset) {
			state.calledOffset = offset
		},

		SET_TRIALS_TOTAL(state, total) {
			state.trialsTotal = total
		},

		SET_TRIALS_BY_SECONDARY_NUMBERS(state, trials) {
			const trialsBySecondaryNumbers: any[] = []

			trials.forEach((trial) => {
				if (trial.secondaryNumbers && trial.secondaryNumbers.length) {
					trial.secondaryNumbers.forEach((secNum, index) => {
						if (secNum.active) {
							trialsBySecondaryNumbers.push({
								...trial,
								idSec: `trial-${trial.id}-secondaryNumber-${index}`,
								secNumMain: secNum
							})
						}
					})
				}
				trialsBySecondaryNumbers.push({
					...trial,
					idSec: `trial-${trial.id}`,
				})
				// else {
				// 	trialsBySecondaryNumbers.push({
				// 		...trial,
				// 		idSec: `trial-${trial.id}`,
				// 	})
				// }
			})

			state.trialsBySecondaryNumbers = trialsBySecondaryNumbers
		},

		SET_TRIAL(state, trial) {
			let index

			state.trialsList.find((t, i) => {
				if (t.id === trial.id) {
					index = i
				}
			})

			const oldList = state.trialsList.slice()

			oldList[index] = trial

			state.trialsList = oldList
		},
	},
	actions: {
		fetchTrials: async function (context, offset): Promise<object[]> {
			let url = '/api/trials'

			if (offset) {
				url += '?offset=' + offset
			}

			if (
				!context.state.calledOffset ||
				offset > context.state.calledOffset
			) {
				context.commit('SET_CALLED_OFFSET', offset)

				const respTrials = await fetch.get(url)

				const data = respTrials.data

				// context.commit('SET_TRIALS_TOTAL', data.total)
				context.commit('SET_TRIALS_LIST', data.trials)

				return data
			} else {
				return []
			}
		},
		fetchAllTrials: async function (context): Promise<object[]> {
			const response = await fetch.get('/api/trials')
			const data = response.data

			context.commit('SET_TRIALS_BY_SECONDARY_NUMBERS', data)

			return data
		},
		fetchSaveTrial: async function (context, trial) {
			const data = await fetch.put('/api/trials', trial)

			return data
		},
		updateTrial: async function (context, trial) {
			context.commit('SET_TRIAL', trial)
		},
	},
}

function formatCNJ(val) {
	return tableHelper.formatCNJ(val)
}
